import { useSelector } from 'react-redux';

import { RootState } from '@/store';

export default function useIsSignedIn() {
  const isSignedIn = useSelector(
    (state: RootState) =>
      state.auth.accessToken !== '' && state.auth.username !== ''
  );

  return isSignedIn;
}
